import React from "react";
import { Radar } from "react-chartjs-2";
import useMediaQueryUI from "@material-ui/core/useMediaQuery";
import { useRecoilValue } from "recoil";
import { themeState } from "../lib/recoil";

function RadarChart({ chartData }) {
  const prefersDarkMode = useMediaQueryUI("(prefers-color-scheme: dark)");

  const themeSelection = useRecoilValue(themeState);

  const data = {
    labels: ["Arme", "Bauch", "Beine", "Oberkörper", "Po"],
    datasets: [
      {
        label: "Body parts",
        backgroundColor:
          themeSelection === "dark"
            ? "#6999dd66"
            : themeSelection === "light"
            ? "#0e4da466"
            : prefersDarkMode
            ? "#6999dd66"
            : "#0e4da466",
        borderColor:
          themeSelection === "dark"
            ? "#6999dd"
            : themeSelection === "light"
            ? "#0e4da4"
            : prefersDarkMode
            ? "#6999dd"
            : "#0e4da4",
        borderWidth: 1.5,
        pointBackgroundColor:
          themeSelection === "dark"
            ? "#6999dd"
            : themeSelection === "light"
            ? "#0e4da4"
            : prefersDarkMode
            ? "#6999dd"
            : "#0e4da4",
        pointBorderColor:
          themeSelection === "dark"
            ? "#6999dd"
            : themeSelection === "light"
            ? "#0e4da4"
            : prefersDarkMode
            ? "#6999dd"
            : "#0e4da4",
        pointHoverBackgroundColor:
          themeSelection === "dark"
            ? "#6999dd"
            : themeSelection === "light"
            ? "#0e4da4"
            : prefersDarkMode
            ? "#6999dd"
            : "#0e4da4",
        pointHoverBorderColor:
          themeSelection === "dark"
            ? "#6999dd"
            : themeSelection === "light"
            ? "#0e4da4"
            : prefersDarkMode
            ? "#6999dd"
            : "#0e4da4",
        data: [
          chartData.percentageArms,
          chartData.percentageAbs,
          chartData.percentageLegs,
          chartData.percentageUpperBody,
          chartData.percentageAss,
        ],
      },
    ],
  };

  const options = {
    layout: {
      padding: {
        left: 28,
      },
    },
    scale: {
      ticks: {
        min: 0,
        max: 100,
        stepSize: 20,
        showLabelBackdrop: false,
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      angleLines: {
        color:
          themeSelection === "dark"
            ? "rgba(255, 255, 255, 0.2)"
            : themeSelection === "light"
            ? "rgba(0, 0, 0, 0.15)"
            : prefersDarkMode
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, .15)",
        lineWidth: 1,
      },
      gridLines: {
        color:
          themeSelection === "dark"
            ? "rgba(255, 255, 255, 0.2)"
            : themeSelection === "light"
            ? "rgba(0, 0, 0, 0.15)"
            : prefersDarkMode
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, .15)",
      },
      pointLabels: {
        fontSize: 12,
        fontColor:
          themeSelection === "dark"
            ? "rgba(255, 255, 255, 0.85)"
            : themeSelection === "light"
            ? "rgba(0, 0, 0, 0.85)"
            : prefersDarkMode
            ? "rgba(255, 255, 255, 0.85)"
            : "rgba(0, 0, 0, 0.85)",
        fontFamily: "'Inter', sans-serif",
        fontStyle: "bold",
      },
    },
    legend: {
      display: false,
    },
  };

  return (
    <>
      <Radar data={data} width={100} height={100} options={options} />
    </>
  );
}

export default RadarChart;
